<template>
  <v-dialog
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
    max-width="700px"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Tipos de Turno del Profesional</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-4">
        <v-row>
          <v-col cols="12">
            <h3 style="color: indigo">
              Profesional: {{ nombreProfesional }}
            </h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-alert type="info" outlined dense class="mb-4">
              Seleccione los tipos de turno disponibles para este profesional.
              Si no selecciona ninguno, todos los tipos de turno estarán
              disponibles.
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="loading">
          <v-col cols="12" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-col>
        </v-row>
        <v-row v-else-if="tiposTurnoInstitucion.length === 0">
          <v-col cols="12">
            <v-alert type="warning" outlined dense>
              No hay tipos de turno configurados para la institución.
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12">
            <v-chip-group
              v-model="tiposTurnoSeleccionados"
              column
              multiple
              active-class="primary--text"
            >
              <v-chip
                v-for="tipo in tiposTurnoInstitucion"
                :key="tipo.idTipoTurno"
                :value="tipo.idTipoTurno"
                filter
                outlined
                label
              >
                {{ tipo.nombreTipoTurno }}
                <span v-if="tipo.sigla" class="ml-1 grey--text text--darken-1">
                  ({{ tipo.sigla }})
                </span>
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          :disabled="saving"
          :loading="saving"
          @click.stop="guardarTiposTurno"
        >
          Guardar
        </v-btn>
        <v-btn color="error" @click.stop="show = false">Salir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "../../axios-auth.js";

export default {
  name: "TiposTurnoProfesional",
  props: ["visible", "idProfesional", "nombreProfesional"],
  data() {
    return {
      tiposTurnoInstitucion: [],
      tiposTurnoSeleccionados: [],
      loading: false,
      saving: false,
    };
  },
  computed: {
    show: {
      get() {
        if (this.visible) {
          this.cargarTiposTurno();
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    async cargarTiposTurno() {
      this.loading = true;
      this.tiposTurnoInstitucion = [];
      this.tiposTurnoSeleccionados = [];

      const idInstitucion =
        this.$store.state.usuario.institucion.idInstitucion;

      try {
        // Cargar todos los tipos de turno de la institución
        const responseTodos = await axios.get("/Profesional/GetTiposTurno", {
          params: { idInstitucion },
        });

        if (responseTodos.data != null && responseTodos.data !== "") {
          this.tiposTurnoInstitucion = responseTodos.data;
        }

        // Cargar tipos de turno asociados al profesional (solo asociaciones explícitas)
        const responseAsociados = await axios.get(
          `/Profesional/${this.idProfesional}/tipos-turno-asociados`
        );

        if (responseAsociados.data != null && responseAsociados.data !== "") {
          this.tiposTurnoSeleccionados = responseAsociados.data;
        }
      } catch (error) {
        this.showAlert({
          icon: "error",
          title: "Error al cargar los tipos de turno",
          vm: this,
        });
      } finally {
        this.loading = false;
      }
    },

    guardarTiposTurno() {
      this.$swal({
        title: "Guardar Tipos de Turno",
        text:
          this.tiposTurnoSeleccionados.length === 0
            ? "No seleccionó ningún tipo de turno. El profesional tendrá disponibles todos los tipos de turno. ¿Desea continuar?"
            : "¿Desea guardar la configuración de tipos de turno?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.saving = true;
          const datos = {
            idProfesional: this.idProfesional,
            tiposTurnoIds: this.tiposTurnoSeleccionados,
          };

          let self = this;
          axios
            .post(`/Profesional/${this.idProfesional}/tipos-turno`, datos)
            .then((response) => {
              self.showAlert({
                icon: "success",
                title: "Tipos de turno guardados exitosamente",
                vm: self,
              });
              self.$emit("tiposTurnoGuardados");
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "No se pudieron guardar los tipos de turno",
                vm: self,
              });
            })
            .finally(() => {
              self.saving = false;
            });
        }
      });
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
  },
};
</script>
